import {
    Box,
    Button,
    Container,
    Flex,
    Image,
    PasswordInput,
    Stack,
    Text,
    TextInput,
    Title,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import axios from "axios";
import { useLayoutEffect, useState } from "react";
import { API_URL } from "../../services/url";
import checkUserId from "../../utils/checkuserid";
import { IconUser } from "@tabler/icons-react";

interface SignUpResponse {
    success: boolean;
    response: string;
    user?: number;
    token?: string;
}

export const Usersignup = () => {
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[\w!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/;

    const isMobile = useMediaQuery("(max-width: 600px)");

    const [name, setName] = useState("");

    const [email, setEmail] = useState("");
    const [invalidEmail, setInvalidemail] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState("");
    const [invalidphone, setInvalidPhone] = useState(false);

    const [password, setPassword] = useState("");
    const [passwordErr, setPasswordErr] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const user = localStorage.getItem('user');

    useLayoutEffect(() => {
        if (user) {
            window.location.href = ('/book')
        } else {
            setLoading(false)
        }
    }, []);

    const isFormValid =
        name &&
        email &&
        phoneNumber &&
        password &&
        confirmPassword &&
        !invalidEmail &&
        !invalidphone &&
        !passwordErr &&
        !confirmPasswordErr;

    const handleSignUp = async (e: any) => {
        e.preventDefault();
        if (!isFormValid) {
            setError("Please fill all required fields");
            return;
        }
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        setLoading(true);
        setError("");
        try {
            const response = await axios.post<SignUpResponse>(`${API_URL}user/signup/`, {
                name,
                email,
                phonenumber: phoneNumber,
                password,
            });

            if (response.data.success) {
                console.log("🚀 ~ handleSignUp ~ response:", response.data);
                localStorage.setItem("user", email);
                window.location.href = "/book";
                setLoading(false);
            } else {
                console.error("User sign up failed", response.data.response);
                setError(response.data.response);
                setLoading(false);
            }
        } catch (error) {
            console.error("User sign up failed", error);
            setError("An error occurred during user sign up");
            setLoading(false);
        }
    };

    const onChangeConfirmPassword = (e: any) => {
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            setConfirmPasswordErr(true);
        } else {
            setError("");
            setConfirmPasswordErr(false);
        }
    };

    const isInvalidPhonenumber = () => {
        const re = /^^(?:\+?61|0)[2-478]\d{8}$/;
        if (!re.test(phoneNumber)) {
            setInvalidPhone(true);
            setError("Invalid phone number");
        } else {
            setInvalidPhone(false);
            setError("");
        }
    };

    function validateEmail() {
        // Regular expression for email validation
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!regex.test(email)) {
            setInvalidemail(true);
            setError("Invalid email address");
        } else {
            setInvalidemail(false);
            setError("");
        }
    }

    const validatePass = (value: string) => {
        if (!passwordPattern.test(value)) {
            setError("Password must contain at least one uppercase, one number and minimum 8 characters");
            setPasswordErr(true);
            return true;
        } else {
            setError("");
            setPasswordErr(false);
            return false;
        }
    };

    return (
        <Container
            fluid
            px="lg"
            py={isMobile ? "md" : "xl"}
            style={{
                height: "95vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "left",
            }}
            bg={"bg"}
        >
            <Box
                style={{
                    background: "linear-gradient(135deg, #2B2B2B, #404040)",
                    borderRadius: "50%",
                    width: "100px",
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "20px"
                }}
            >
                <Flex direction={'column'} align={'center'}>
                    <IconUser color="white" />
                    <Text size="xl" fw={700} c="white">
                        USER
                    </Text>
                </Flex>
            </Box>
            <Title order={1} style={{ fontSize: isMobile ? "2rem" : "4rem" }}>
                Kabbie
            </Title>
            <Flex
                direction="row"
                align="center"
                justify="center"
                style={{ width: "100%" }}
            >
                <Stack style={{ width: "100%" }} maw={'60rem'}>
                    <Title order={2} style={{ fontSize: "1.5rem" }}>
                        User Signup
                    </Title>

                    <TextInput
                        label="Name"
                        placeholder="Enter your name"
                        type="text"
                        required
                        size="md"
                        mb="sm"
                        labelProps={{ style: { alignSelf: "flex-start" } }}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />

                    <TextInput
                        label="Email"
                        placeholder="Enter your email"
                        type="email"
                        required
                        size="md"
                        mb="sm"
                        labelProps={{ style: { alignSelf: "flex-start" } }}
                        value={email}
                        error={invalidEmail}
                        onChange={(e) => setEmail(e.target.value.toLocaleLowerCase())}
                        onBlur={validateEmail}
                    />

                    <TextInput
                        label="Phone Number"
                        placeholder="Enter your phone number"
                        type="tel"
                        required
                        size="md"
                        mb="sm"
                        error={invalidphone}
                        labelProps={{ style: { alignSelf: "flex-start" } }}
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        onBlur={isInvalidPhonenumber}
                    />

                    <PasswordInput
                        label="Password"
                        placeholder="Enter your password"
                        required
                        mb="sm"
                        size="md"
                        error={passwordErr}
                        labelProps={{ style: { alignSelf: "flex-start" } }}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocusCapture={(e) => setError("")}
                        onBlurCapture={(e) => validatePass(e.target.value)}
                    />

                    <PasswordInput
                        label="Confirm Password"
                        placeholder="Enter your password"
                        required
                        mb="sm"
                        error={confirmPasswordErr}
                        size="md"
                        labelProps={{ style: { alignSelf: "flex-start" } }}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        onFocusCapture={(e) => setError("")}
                        onBlurCapture={onChangeConfirmPassword}
                    />

                    {error && (
                        <Text color="red" size="sm" mb="md">
                            {error}
                        </Text>
                    )}

                    <Flex justify={"center"}>
                        <Button
                            w={"90%"}
                            size="md"
                            mt="sm"
                            onClick={handleSignUp}
                            variant="gradient"
                            gradient={{ from: "#2B2B2B", to: "#404040", deg: 180 }}
                            c={"fcolor"}
                            loading={loading}
                            loaderProps={{ type: "oval" }}
                            radius={"md"}
                        >
                            Create Account
                        </Button>
                    </Flex>

                    <Text size="sm" ta={"center"}>
                        Already have an account?{" "}
                        <Text component="a" href="/user/signin" inherit>
                            Login
                        </Text>
                    </Text>
                </Stack>
            </Flex>
        </Container>
    )
}